import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { ModalBuilder } from '../modals/ModalBuilder.esm.js';
import FulfillGenesInRemainingGroupsModal from '../modals/customModals/FulfillGenesInRemainingGroupsModal/FulfillGenesInRemainingGroupsModal.esm.js';
import SaveCustomOrderModal from '../modals/customModals/SaveCustomOrderModal/SaveCustomOrderModal.esm.js';
import LoadingOverlay from '../components/LoadingOverlay/LoadingOverlay.esm.js';
import { useMakeCartContext, CartContext } from './CartContext.esm.js';

var CartContextWrapper = function (_a) {
    var apiParameters = _a.apiParameters, children = _a.children, gotoCartPage = _a.gotoCartPage, rest = __rest(_a, ["apiParameters", "children", "gotoCartPage"]);
    var context = useMakeCartContext(__assign({ apiParameters: apiParameters, gotoCartPage: gotoCartPage }, rest));
    var customModalProps = context.customModalProps, errors = context.errors, requestPending = context.requestPending;
    var fulfillGenesInRemainingGroupsModalProps = customModalProps.fulfillGenesInRemainingGroupsModalProps, saveCustomPanelModalProps = customModalProps.saveCustomPanelModalProps;
    var modalType = errors === null || errors === void 0 ? void 0 : errors.validationCode;
    return (React__default.createElement(CartContext.Provider, { value: context },
        children,
        React__default.createElement(ModalBuilder, { actionParameters: { concepts: errors === null || errors === void 0 ? void 0 : errors.replacementConcepts }, modalType: modalType, postProcessingParameters: {
                country: errors === null || errors === void 0 ? void 0 : errors.country,
                errorTypes: errors === null || errors === void 0 ? void 0 : errors.errorSubTypes,
                invalidTestNames: errors === null || errors === void 0 ? void 0 : errors.invalidTestNames,
                message: errors === null || errors === void 0 ? void 0 : errors.errorMessage,
            } }),
        fulfillGenesInRemainingGroupsModalProps && (React__default.createElement(FulfillGenesInRemainingGroupsModal, __assign({}, fulfillGenesInRemainingGroupsModalProps))),
        saveCustomPanelModalProps && React__default.createElement(SaveCustomOrderModal, __assign({}, saveCustomPanelModalProps)),
        requestPending && React__default.createElement(LoadingOverlay, null)));
};

export { CartContextWrapper };
//# sourceMappingURL=CartContextWrapper.esm.js.map
